export const confirmationActionTypes = {
	TOGGLE_CONFIRMATION_MODAL: 'TOGGLE_CONFIRMATION_MODAL',
	CLEAR_CONFIRMATION_MODAL_STATE: 'CLEAR_CONFIRMATION_MODAL_STATE',
} as const;

export type ConfirmationActionType =
	(typeof confirmationActionTypes)[keyof typeof confirmationActionTypes];
